import React, { useContext } from "react";
import View from "common/View";
import SoftwareList from "./SoftwareList";
import SoftwareAdminHelp from "./Help";


const options = [
  {
    signal: "install-software",
    label: "Install",
  },
];

export const SoftwareAdmin = () => {
  return (
  <View
    title="Software Packages"
    className="container-lg"
    options={options}
    Help={SoftwareAdminHelp}
  >
    <SoftwareList />
  </View>
)};

export default SoftwareAdmin;
